const WhyChooseUs = () => {
  const leftPoints = [
    "Sustainable, Natural & Organic Products",
    "Global Quality Standards",
    "Lab Tested",
  ];

  const rightPoints = [
    "Diverse Product Range",
    "Trusted Partnerships",
    "Timely Delivery",
  ];

  return (
    <section className="bg-[#fff5e1] py-16 px-4 overflow-hidden">
      {/* Title */}
      <div className="text-center mb-12">
        <h2 className="inline-block bg-[#8b4e24] text-white text-xl md:text-2xl font-bold px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 hover:-translate-y-1">
          WHY CHOOSE US ?
        </h2>
      </div>

      {/* Cards */}
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-8 justify-center">
        {/* Left Card */}
        <div className="bg-[#a05e2a] text-white rounded-xl shadow-2xl hover:shadow-2xl p-6 md:p-8 flex-1 transition-all duration-500 hover:-translate-y-2 transform-gpu"
             style={{
               transformStyle: 'preserve-3d',
               perspective: '1000px'
             }}>
          <div className="transform-gpu transition-transform duration-500 hover:rotate-x-2">
            <ul className="space-y-6">
              {leftPoints.map((point, idx) => (
                <li
                  key={idx}
                  className="flex items-start gap-3 md:gap-4 transform-gpu transition-all duration-300 hover:translate-x-2 hover:scale-105"
                  style={{
                    animation: `slideInLeft 0.6s ease-out ${idx * 0.2}s both`
                  }}
                >
                  <div className="w-9 h-9 md:w-10 md:h-10 flex-shrink-0 bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full flex items-center justify-center shadow-lg transform-gpu transition-all duration-300 hover:scale-110 hover:rotate-12">
                    <svg
                      className="w-5 h-5 md:w-6 md:h-6 text-white drop-shadow-md"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span className="text-base md:text-lg font-medium text-white drop-shadow-md leading-relaxed">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right Card */}
        <div className="bg-[#a05e2a] text-white rounded-xl shadow-2xl hover:shadow-2xl p-6 md:p-8 flex-1 transition-all duration-500 hover:-translate-y-2 transform-gpu"
             style={{
               transformStyle: 'preserve-3d',
               perspective: '1000px'
             }}>
          <div className="transform-gpu transition-transform duration-500 hover:rotate-x-2">
            <ul className="space-y-6">
              {rightPoints.map((point, idx) => (
                <li
                  key={idx}
                  className="flex items-start gap-3 md:gap-4 transform-gpu transition-all duration-300 hover:translate-x-2 hover:scale-105"
                  style={{
                    animation: `slideInRight 0.6s ease-out ${idx * 0.2}s both`
                  }}
                >
                  <div className="w-9 h-9 md:w-10 md:h-10 flex-shrink-0 bg-gradient-to-br from-[#FFD700] to-[#FFA500] rounded-full flex items-center justify-center shadow-lg transform-gpu transition-all duration-300 hover:scale-110 hover:rotate-12">
                    <svg
                      className="w-5 h-5 md:w-6 md:h-6 text-white drop-shadow-md"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span className="text-base md:text-lg font-medium text-white drop-shadow-md leading-relaxed">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Add CSS for animations */}
      <style jsx>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px) rotateY(20deg);
          }
          to {
            opacity: 1;
            transform: translateX(0) rotateY(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px) rotateY(-20deg);
          }
          to {
            opacity: 1;
            transform: translateX(0) rotateY(0);
          }
        }

        /* Scroll trigger animations */
        .scroll-animate {
          animation: fadeInUp 0.8s ease-out;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(50px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        /* Enhanced 3D effects */
        .card-3d {
          transform: translateZ(20px);
          box-shadow: 
            0 10px 30px rgba(139, 78, 36, 0.3),
            0 0 0 1px rgba(255, 255, 255, 0.1);
        }

        .card-3d:hover {
          transform: translateZ(30px) rotateX(5deg);
          box-shadow: 
            0 20px 40px rgba(139, 78, 36, 0.4),
            0 0 0 1px rgba(255, 255, 255, 0.2);
        }
      `}</style>
    </section>
  );
};

export default WhyChooseUs;